import classNames from 'classnames';
import React from 'react';

const WithPermissions = (WrappedComponent) => {
  return (props) => {
    const { className,shouldMask, ...rest } = props;

    const classes = classNames({
      modified: true,
      blocked_data: shouldMask,
    }, className);

    return (
    <div className={classes} >
        <WrappedComponent {...rest} />
    </div>
    );
  }
};

export default WithPermissions;
